import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StripeProduct } from "../stripe-product";

export class StripePayment
{
	public name: string;
	public currency: string;
	public product: StripeProduct;
	public successUrl: string;
	public cancelUrl: string;

	public constructor(name: string, currency: string, product: StripeProduct,
		successUrl: string, cancelUrl: string)
	{
		this.name = name;
		this.currency = currency;
		this.product = product;
		this.successUrl = successUrl;
		this.cancelUrl = cancelUrl;
	}
}

export class StripeTransaction
{
	public id: string;
	public orderNumber: number;
	public orderId: string;
	public creditAmount: number;
	public creditCost: number;
	public taxCost: number;
	public createdInstantMillisFromEpoch: number;
	public customerEmail: string;
	public userId: string;
	public status: string;
}

@Injectable()
export class PurchaseRepository
{
	private requestMapping: string = "stripe";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public uploadeFile(payment: StripePayment): Observable<any>
	{
		return this.http.post(`${this.requestMapping}/payment`, payment);
	}

	public getTransaction(transactionId: string): Observable<StripeTransaction>
	{
		return this.http.get<StripeTransaction>(`${this.requestMapping}/transactions/${transactionId}`);
	}
}
